package com.example.mystybag.core.model

/**
 * Model for showing a full-screen image overlay at app root (covers entire screen including status bar).
 * Used when a bottom sheet or dialog wants to show an image on top of everything without closing.
 */
data class FullScreenImageOverlay(
    val url: String,
    val onClose: () -> Unit
)
